/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/

export const INTERFACE_LANGUAGE_OPTIONS = [
  { code: 'zh', label: '简体中文' },
  { code: 'zh-Hant', label: '繁體中文' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'ru', label: 'Русский' },
  { code: 'ja', label: '日本語' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'ar', label: 'العربية' },
] as const

export type InterfaceLanguageCode =
  (typeof INTERFACE_LANGUAGE_OPTIONS)[number]['code']

// RTL（从右到左）语种：切换这些语言时界面需翻转方向
export const RTL_LANGUAGES = ['ar', 'fa', 'he', 'ur'] as const

export function isRTLLanguage(lang?: string | null): boolean {
  if (!lang) return false
  const code = lang.trim().replace(/_/g, '-').toLowerCase().split('-')[0]
  return (RTL_LANGUAGES as readonly string[]).includes(code)
}

export function normalizeInterfaceLanguage(value?: string | null): string {
  // English is the default language; first-time visitors land on English.
  if (!value) return 'en'

  const normalized = value.trim().replace(/_/g, '-').toLowerCase()
  // 繁体中文：保持独立语种代码，避免被归并到简体 zh
  if (normalized.startsWith('zh-hant')) return 'zh-Hant'
  if (normalized.startsWith('zh')) return 'zh'

  return INTERFACE_LANGUAGE_OPTIONS.some((lang) => lang.code === normalized)
    ? normalized
    : 'en'
}
